import React, { type ReactNode } from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';

const styles = cssMap({
	frame: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '56px',
		height: '60px',
	},
	avatar: {
		width: '96px',
		height: '96px',
		flexShrink: 0,
		transform: 'scale(0.56)',
		transformOrigin: 'center',
	},
});

/** Centers the loaded avatar and skeleton in the same 56-by-60-pixel slot without clipping their tips. */
export const ExternalAgentAvatarFrame = ({
	children,
}: {
	children: ReactNode;
}): React.JSX.Element => (
	<Box xcss={styles.frame}>
		<Box xcss={styles.avatar}>{children}</Box>
	</Box>
);
